<template>
  <div>
    <Navbar />
    <Header />
    <div class="video" style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        src="https://player.vimeo.com/video/677942333?h=ec0fc83d9b"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div class="how container">
      <h1>How Does It Work?</h1>
      <p>The Traitz tool allows artists to input individual graphics of character traits. For example artists could input 20 hats, 15 glasses, 12 face tattoos, and 10 facial expressions - the Traitz tool then mixes and matches these artworks to create a huge number of unique combinations.</p>
      <p>The tool could be used to generate large scale projects like Vessels Gen-0 or Neonz, or it could be used for smaller collections. It's a powerful tool for artists to rapidly explore the potential of their own art.</p>
      <hr />
    </div>
    <Features />
    <div class="quote">
      <h1>
        “A tool that gives Artists full control to <br />curate their Generative
        Collection”
      </h1>
    </div>
    <EOI />
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Header from "./components/Header.vue";
import Features from "./components/Features.vue";
import EOI from "./components/EOI.vue";
import Footer from './components/Footer.vue'
export default {
  name: "App",
  components: {
    Navbar,
    Header,
    Features,
    EOI,
    Footer
  },
};
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.video {
  width: 100vw;
  body {
    width: 100vw;
  }
  iframe {
    width: 100vw !important;
  }
}

.how {
  h1 {
    text-align: center;
    letter-spacing: 0.02em;
    // letter-spacing: inherit;
    padding-top: 75px;
    padding-bottom: 25px;
    @include media('>=tablet') {
    padding-top: 150px;

    }
  }
  p {
    margin: 50px auto;
  }
  p:nth-child(3) {
    margin-bottom: 75px;
    @include media('>=tablet') {
    margin-bottom: 100px;

    }
  }
  hr {
    width: 50%;
    margin: auto;
    opacity: 0.2;
  }
}

.quote {
  background: url("./assets/bespoke-bg.png") no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 400px;
  padding: 0 50px;
  font-size: 40px;
  @include media(">tablet") {
    padding: 0 100px;
    height: 600px;
  }
  h1 {
    letter-spacing: inherit;
    font-size: 33px;
    @include media(">tablet") {
      font-size: 52px;
    }
    @include media("<1100px") {
      br {
        display: none;
      }
    }
  }
}
</style>
